const icon = require('vue-svgicon');
icon.register({
    'lens-feature-anti-glare': {
        width: 40,
        height: 40,
        viewBox: '0 0 40 40',
        data: `<path pid="0" d="M6 16c7 0 14 7 14 14 0-7 7-14 14-14-7 0-14-7-14-14 0 7-7 14-14 14z" _stroke="#000" stroke-linejoin="bevel"/><path pid="1" d="M6 24c7 0 14 7 14 14 0-7 7-14 14-14-7 0-14-7-14-14 0 7-7 14-14 14z" _stroke="#000" stroke-linejoin="bevel"/>`,
    },
});
